@use "../../../../styles/text";
@use "../../../../styles/icon-sizes";

:host {
  display: block;
  background-color: var(--color-neutral-xxlight);
  margin: var(--spacing-xxs) 0 0;
  padding: 0;
  width: 100%;

  .select-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    border: 1px solid var(--color-neutral-base);
    border-radius: 0;
    height: var(--field-height-md);

    &.height-selection-sm {
      height: var(--field-height-sm);
    }

    hp6-icon {
      display: inline-block;
      position: absolute;
      right: var(--spacing-xs);
    }

    hp6-icon.validation-icon {
      right: calc(var(--spacing-xs) + #{icon-sizes.$icon-size-sm});
    }
  }
}

::slotted(select) {
  @include text.text-body-sm;
  height: 100%;
  width: 100%;
  // required to be "16px" not the var, to prevent iPhone zoom on focus
  font-size: 16px;
  margin: var(--spacing-xxs) 0 0;
  color: var(--color-text-base);
  border: none;
  padding-top: 1px;
  padding-left: calc(1px + var(--spacing-xs));
  padding-right: calc(var(--spacing-xs) + #{icon-sizes.$icon-size-sm} + var(--spacing-xs));
  padding-bottom: 1px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: transparent;
  position: relative;
  z-index: 1;

  &:focus {
    // required to be "16px" not the var, to prevent iPhone zoom on focus
    font-size: 16px;
  }

  &::-ms-expand {
    display: none;
  }
}

:host(.valid) {
  .select-wrapper {
    border: 2px solid var(--color-success-base);
    border-color: var(--color-success-base);
    padding-top: 0;
    padding-bottom: 0;
    hp6-icon[name="system-success"] {
      --system-color: var(--color-success-base);
    }
    ::slotted(select) {
      padding-right: calc(var(--spacing-xs) + #{icon-sizes.$icon-size-sm} + #{icon-sizes.$icon-size-sm} + var(--spacing-xs) - 1px);
    }
  }
}

:host(.invalid) {
  .select-wrapper {
    border: 2px solid var(--color-error-base);
    border-color: var(--color-error-base);
    padding-top: 0;
    padding-bottom: 0;
    hp6-icon[name="system-error"] {
      --system-color: var(--color-error-base);
    }
    ::slotted(select) {
      padding-right: calc(var(--spacing-xs) + #{icon-sizes.$icon-size-sm} + #{icon-sizes.$icon-size-sm} + var(--spacing-xs) - 1px);
    }
  }
}
